export const STATS_SEASON = '2026-27';
export const CONTENT_SEASON = '2026-27';
export const SCHEDULE_SEASON = '2026-27';
export const HISTORICAL_STATS_SEASON = '2025-26';
